import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    checkActionCode,
    confirmPasswordReset,
    verifyResetingPassword
} from '../../../../servises/auth.service';
import { BoxedStyled } from '../../../../style/components/common.styled';
import LoaderComponent from '../../../components/Loader.component';
import styled from 'styled-components';
import { PrimaryButton, TextField } from '@fluentui/react';
import { FormItem } from '../../auth/Auth.styled';

const Styles = styled.div`
  text-align: center;
  padding: 30px;
  font-size: 19px;
  line-height: 1.3;
`;

const ResetPassword = props => {
    const { oobCode } = props;

    const history = useHistory();

    const [inputText, setInputText] = useState('');
    const [loader, setLoader] = useState(true);
    const [resetingVerified, setResetingVerified] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [messageSent, setMessageSent] = useState(false);

    useEffect(() => {
        let active = true;

        const checkResetCode = async () => {
            try {
                await checkActionCode(oobCode);
                await verifyResetingPassword(oobCode);
                if (active) {
                    setResetingVerified(true);
                }
            } catch (error) {
                if (active) {
                    setErrorMessage(error.message);
                }
            } finally {
                if (active) {
                    setLoader(false);
                }
            }
        };

        checkResetCode();
        return () => {
            active = false;
        };
    }, [oobCode]);

    const handleSubmit = async () => {
        if (messageSent) {
            return;
        }
        setMessageSent(true);
        try {
            await confirmPasswordReset(oobCode, inputText);
            history.push('/servers');
        } catch (error) {
            setErrorMessage(error.message);
            setMessageSent(false);
        }
    };

    return (
        <BoxedStyled>
            { loader && (
                <LoaderComponent/>
            ) }

            { !loader && errorMessage && (
                <Styles>{ errorMessage }</Styles>
            ) }

            { !loader && resetingVerified && (
                <>
                    <FormItem>
                        <TextField label="New password"
                                   value={ inputText }
                                   type={ "password" }
                                   canRevealPassword
                                   onChange={ (e) => setInputText(e.target.value) }
                        />
                    </FormItem>
                    <FormItem>
                        <PrimaryButton
                            text="Save"
                            disabled={ messageSent }
                            onClick={ handleSubmit }
                        />
                    </FormItem>
                </>
            ) }
        </BoxedStyled>
    );
};

export default ResetPassword;
